import { BaseRestDataProvider } from './BaseRestDataProvider';
import { CompanyInfo } from '../models/CompanyInfo';

export class CompanyInfoRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/company-info');
  }

  getInfo(): Promise<CompanyInfo> {
    return this.get<CompanyInfo>(``);
  }

  saveInfo(info: CompanyInfo): Promise<void> {
    return this.put<void>(``, info);
  }
}

export type { CompanyInfo };
